import { render, staticRenderFns } from "./Contactability.vue?vue&type=template&id=0f2a9826&scoped=true&"
import script from "./Contactability.vue?vue&type=script&lang=js&"
export * from "./Contactability.vue?vue&type=script&lang=js&"
import style0 from "./Contactability.vue?vue&type=style&index=0&id=0f2a9826&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2a9826",
  null
  
)

export default component.exports